import React, { createRef } from "react";
import moment from "moment-timezone";
import classes from "./CustomCalendar.module.css";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { HiClock } from "react-icons/hi";
import $ from "jquery";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import LessonCard from "../../components/PopUps/Schedule/LessonCard";

class CustomFullCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = createRef();
  }
  state = {
    currentMonth: moment().format(),
    selectedDate: new Date(moment().startOf("week").format()),
    calendarType:
      this.props?.calendarType !== undefined
        ? this.props?.calendarType
        : "month",
    array:
      this.props?.ScheduleData !== undefined
        ? this.props?.ScheduleData
        : [
            {
              startTime: moment(moment().add(-3, "hours").format())
                .add(0, "days")
                .format(),
              endTime: moment(moment().add(3, "hours").format())
                .add(0, "days")
                .format(),
              type: "1-on-1",
              id: 1,
              title: "Tennis Lesson with Jenny",
              eventDate: moment().add(0, "days").format(),
              location: "Green Tennis Court",
              status: "upcoming",
            },
            {
              startTime: moment(moment().add(5, "hours").format())
                .add(1, "days")
                .format(),
              endTime: moment(moment().add(8, "hours").format())
                .add(0, "days")
                .format(),
              type: "1-on-1",
              id: 2,
              title: "Tennis Lesson with Jenny",
              eventDate: moment().add(0, "days").format(),
              location: "Green Tennis Court",
              status: "pending",
            },
            {
              startTime: moment(moment().add(9, "hours").format())
                .add(2, "days")
                .format(),
              endTime: moment(moment().add(11, "hours").format())
                .add(0, "days")
                .format(),
              type: "1-on-1",
              id: 3,
              title: "Tennis Lesson with Jenny",
              eventDate: moment().add(0, "days").format(),
              location: "Green Tennis Court",
              status: "past",
            },
          ],
    screenWidth: window?.innerWidth,
    show: false,
    selectedItem: null,
    anchorE1: null,
  };
  componentDidMount() {
    $(`.${classes.MiddleBox}`).parent().css("border-bottom", "0px");
    $(`.${classes.StartBox}`).parent().css("border-bottom", "0px");
    window.addEventListener("resize", this.resize);
    this.myRef?.current !== undefined &&
      this.myRef?.current !== null &&
      this.myRef.current.scrollIntoView({
        inline: "start",
        block: "nearest",
        behavior: "smooth",
      });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  componentDidUpdate() {
    $(`.${classes.MiddleBox}`).parent().css("border-bottom", "0px");
    $(`.${classes.StartBox}`).parent().css("border-bottom", "0px");
    this.myRef?.current !== undefined &&
      this.myRef?.current !== null &&
      this.myRef.current.scrollIntoView({
        inline: "start",
        block: "nearest",
        behavior: "smooth",
      });
  }

  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.calendarType !== this.state.calendarType) {
      this.setState({ calendarType: nextProps.calendarType });
    }
  }

  renderHeader() {
    return (
      <div className={classes.header}>
        <div className={classes.colStart}>
          <span style={{ ...Fonts.h6, color: Colors.neutralShadesOfNero }}>
            {moment(this.state.currentMonth).format("MMMM")}{" "}
          </span>
          {this.state.calendarType == "week" && (
            <span style={{ ...Fonts.h6, color: Colors.neutralShadesOfNero }}>
              {moment(this.state.currentMonth).startOf("week").format("DD")} -{" "}
              {moment(this.state.currentMonth).endOf("week").format("DD")}
            </span>
          )}
          {this.state.calendarType == "day" && (
            <span>{moment(this.state.currentMonth).format("DD")}</span>
          )}
          <MdKeyboardArrowLeft
            onClick={() =>
              this.state.calendarType == "month"
                ? this.prevMonth(0)
                : this.prevWeekOrDay(0)
            }
            style={{ marginRight: "5px", marginLeft: "15px" }}
            className={classes.arrowIcon}
          />
          <MdKeyboardArrowRight
            onClick={() =>
              this.state.calendarType == "month"
                ? this.nextMonth(1)
                : this.nextWeekOrDay(1)
            }
            className={classes.arrowIcon}
          />
        </div>
        <div className={classes.colEnd}>
          <span
            className={`${[
              classes.dayBtn,
              this.state.calendarType == "day" && classes.activeCalanderType,
            ].join(" ")}`}
            onClick={() => {
              this.setState({ calendarType: "day" });
            }}
            style={{
              ...Fonts.h9,
              color:
                this.state.calendarType == "day"
                  ? Colors.mainBlue
                  : Colors.neutralShadesOfNero,
            }}
          >
            Day
          </span>
          <span
            className={`${[
              classes.weekBtn,
              this.state.calendarType == "week" && classes.activeCalanderType,
            ].join(" ")}`}
            onClick={() => {
              this.setState({ calendarType: "week" });
            }}
            style={{
              ...Fonts.h9,
              color:
                this.state.calendarType == "week"
                  ? Colors.mainBlue
                  : Colors.neutralShadesOfNero,
            }}
          >
            Week
          </span>
          <span
            className={`${[
              classes.monthBtn,
              this.state.calendarType == "month" && classes.activeCalanderType,
            ].join(" ")}`}
            onClick={() => {
              this.setState({ calendarType: "month" });
            }}
            style={{
              ...Fonts.h9,
              color:
                this.state.calendarType == "month"
                  ? Colors.mainBlue
                  : Colors.neutralShadesOfNero,
            }}
          >
            Month
          </span>
        </div>
      </div>
    );
  }

  renderMobileHeader() {
    return (
      <div className={classes.mobileHeader}>
        <MdKeyboardArrowLeft
          onClick={() =>
            this.state.calendarType == "month"
              ? this.changeYear(-1)
              : this.prevMonth(0)
          }
          size={30}
        />
        <div>
          {this.state.calendarType !== "month" && (
            <span className={classes.mobileHeaderText}>
              {moment(this.state.currentMonth).format("MMMM")},
            </span>
          )}
          <span
            className={[
              classes.mobileHeaderText,
              this.state.calendarType !== "month" &&
                classes.mobileHeaderTextLightColor,
            ].join(" ")}
          >
            {moment(this.state.currentMonth).format("YYYY")}{" "}
          </span>
        </div>

        <MdKeyboardArrowRight
          onClick={() =>
            this.state.calendarType == "month"
              ? this.changeYear(1)
              : this.nextMonth(1)
          }
          size={30}
        />
      </div>
    );
  }

  renderMonthNameMobileHeader() {
    let months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return (
      <div className={classes.monthNameMobileHeader}>
        {months.map((item, index) => {
          return (
            <span
              ref={
                moment(this.state.currentMonth).format("MMM") == item &&
                this.myRef
              }
              key={index}
              className={[
                classes.monthName,
                moment(this.state.currentMonth).format("MMM") == item &&
                  classes.activeMonth,
              ].join(" ")}
              onClick={() => {
                this.setSelectedMonth(index);
              }}
            >
              {item}
            </span>
          );
        })}
      </div>
    );
  }

  renderDayMobileHeader() {
    const daysInMonth = moment(this.state.currentMonth).daysInMonth();
    const firstDayOfmonth = moment(this.state.currentMonth)
      .startOf("month")
      .format();
    const day = [];

    for (let i = 0; i < daysInMonth; i++) {
      day.push(
        <div
          ref={
            moment(this.state.currentMonth).format("DDD") ==
              moment(firstDayOfmonth).add(i, "days").format("DDD") && this.myRef
          }
          key={i}
          className={[
            classes.mobileWeekDateContainer,
            classes.mobileWeekDayName,
            moment(this.state.currentMonth).format("DDD") ==
              moment(firstDayOfmonth).add(i, "days").format("DDD") &&
              classes.mobileWeekDateContainerActive,
          ].join(" ")}
          onClick={() => {
            this.setState({
              currentMonth: moment(firstDayOfmonth).add(i, "days").format(),
            });
          }}
        >
          <span className={classes.monthNameForWeekCalander}>
            {moment(firstDayOfmonth).add(i, "days").format("ddd")}
          </span>
          <span className={classes.datesForWeekCalander}>
            {moment(firstDayOfmonth).add(i, "days").format("D")}
          </span>
        </div>
      );
    }

    return (
      <div
        className={[
          classes.monthNameMobileHeader,
          classes.dayHeaderConatiner,
        ].join(" ")}
      >
        {day}
      </div>
    );
  }

  renderDays() {
    const days = [
      <div
        className={`${[classes.dayTime, classes.noBorder].join(" ")}`}
      ></div>,
    ];
    let startDate = moment(this.state.currentMonth).startOf("week").format();

    for (let i = 0; i < 7; i++) {
      days.push(
        <div className={classes.weekDay}>
          <span
            className={classes.char}
            key={i}
            style={{
              color: Colors.neutralShadesOfDimGray,
              ...Fonts.otherMedium,
            }}
          >
            {moment(startDate).add(i, "day").format("ddd")}
          </span>
          <br />
          <span
            className={classes.number}
            key={i}
            style={{
              color: Colors.neutralShadesOfNero,
              ...Fonts.h4,
              fontSize: "26px",
            }}
          >
            {moment(startDate).add(i, "day").format("DD")}
          </span>
        </div>
      );
    }

    return <div className={classes.days}>{days}</div>;
  }

  // Change Month handle=> get month in number and year
  changeMonthHandler = (type) => {
    let month = 5;
    let year = 2022;
    // let month = this.props.selectedMonth * 1;
    // let year = this.props.selectedYear * 1;

    switch (type) {
      case 0:
        month = month - 1;
        break;
      case 1:
        month = month + 1;
        break;
      case 2:
        month = moment().format("MM") - 1;
        year = moment().format("YYYY");
        break;
      default:
        month = moment().format("MM") - 1;
        year = moment().format("YYYY");
        break;
    }
    if (month > 11) {
      month = 0;
      year = year + 1;
    } else if (month < 0) {
      month = 11;
      year = year - 1;
    }
    // this.props.setSelectedYear(year);
    // this.props.setSelectedMonth(month);
  };
  nextMonth = async (type) => {
    await this.setState({
      currentMonth: moment(this.state.currentMonth).add(1, "months").format(),
    });
    // Change Month handle=> get month in number and year
    this.changeMonthHandler(type);
  };

  prevMonth = async (type) => {
    let date = moment().format();

    if (
      moment(date).format("YYYY") <=
      moment(this.state.currentMonth).add(-2, "months").format("YYYY")
    ) {
      if (
        moment(date).add(-2, "months").format("MM") <
          moment(this.state.currentMonth).format("MM") ||
        moment(date).format("YYYY") <
          moment(this.state.currentMonth).format("YYYY")
      ) {
        await this.setState({
          currentMonth: moment(this.state.currentMonth)
            .add(-1, "months")
            .format(),
        });
        this.changeMonthHandler(type);
      }
    } else {
      return;
    }
  };
  changeYear = async (number) => {
    this.setState({
      currentMonth: moment(this.state.currentMonth)
        .add(number, "years")
        .format(),
    });
  };
  setSelectedMonth = async (index) => {
    await this.setState({
      currentMonth: moment().set("month", index).format(),
    });
  };

  nextWeekOrDay = async (type) => {
    await this.setState({
      currentMonth: moment(this.state.currentMonth)
        .add(this.state.calendarType == "day" ? 1 : 7, "days")
        .format(),
    });
    // this.changeMonthHandler(type);
  };

  prevWeekOrDay = async (type) => {
    let date = moment().format();
    const newDate = moment(this.state.currentMonth)
      .add(this.state.calendarType == "day" ? -1 : -7, "days")
      .format();

    if (
      moment(date).format("X") < moment(this.state.currentMonth).format("X")
    ) {
      await this.setState({
        currentMonth: newDate,
      });
      // this.changeMonthHandler(type);
    } else {
      return;
    }
  };

  renderDailyCells() {
    const { currentMonth, array } = this.state;

    const rows = [];
    let hours = 0;
    const filterResponse = array.filter(
      (x) =>
        moment(x.eventDate).format("YYYY-MM-DD") ==
        moment(currentMonth).format("YYYY-MM-DD")
    );

    while (hours <= 23) {
      let renderTime = "";
      switch (true) {
        case hours == 0:
          renderTime = "12am";
          break;
        case hours > 0 && hours < 12:
          renderTime = `${hours} am`;
          break;
        case hours == 12:
          renderTime = `Noon`;
          break;
        case hours > 12 && hours < 24:
          renderTime = `${hours - 12} pm`;
          break;
        default:
          renderTime = `${hours} am`;
          break;
      }

      rows.push(
        <div className={classes.cellRow} key={`cellRow ${hours}`}>
          <div className={`col ${[classes.dayCell].join(" ")}`}>
            {
              <div className={`${[classes.hoursContainer].join(" ")}`}>
                <span
                  className={`${[classes.hours].join(" ")}`}
                  style={{
                    color: Colors.neutralShadesOfDimGray,
                    ...Fonts.otherMedium,
                  }}
                >
                  {renderTime}
                </span>
              </div>
            }
            <div className={`${[classes.dailyEventContainer].join(" ")}`}>
              {filterResponse.length > 0 && (
                <>
                  {filterResponse.map((item, i) => {
                    return moment(item.startTime).format("H") == hours ? (
                      <div
                        key={i}
                        className={`${[
                          classes.eventDetailContainer,
                          (item?.status).toLocaleLowerCase() == "upcoming"
                            ? classes.upcoming
                            : (item?.status).toLocaleLowerCase() == "pending"
                            ? classes?.pending
                            : classes.past,
                          this.state.selectedItem?.id == item?.id &&
                            classes?.clickedEvent,
                        ].join(" ")} 
                        `}
                        onClick={(event) => {
                          this.setState({
                            selectedItem: item,
                            show: true,
                            anchorE1: event.currentTarget,
                          });
                        }}
                      >
                        <span
                          className={[
                            classes?.generalTimeAndOtherDetailText,
                            classes.timeAndTitle,
                          ].join(" ")}
                        >
                          <HiClock /> {moment(item?.startTime).format("hh A")}
                          {" - "}
                          {moment(item?.endTime).format("hh A")}
                          {this.state.screenWidth > 991 && ` . ${item?.title}`}
                        </span>
                        <br />
                        {this.state.screenWidth <= 991 && (
                          <>
                            <span
                              className={[
                                classes?.generalTimeAndOtherDetailText,
                                classes.title,
                              ].join(" ")}
                            >
                              {item?.title}
                            </span>
                            <br />
                          </>
                        )}

                        <span
                          className={[
                            classes?.generalTimeAndOtherDetailText,
                            classes.address,
                          ].join(" ")}
                        >
                          {item?.location}
                        </span>
                      </div>
                    ) : null;
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      );
      ++hours;
    }
    return <div className={classes.dateCellContainer}>{rows}</div>;
  }

  renderWeeklyCells() {
    const { currentMonth, array } = this.state;
    const startDate = new Date(moment(currentMonth).startOf("week").format());
    const endDate = new Date(moment(currentMonth).endOf("week").format());

    const rows = [];
    let days = [];
    let day = new Date(moment(startDate).add(-1, "day").format());
    let hours = 0;
    let formattedDate = "";

    while (hours <= 23) {
      for (let i = 0; i < 8; i++) {
        formattedDate = moment(day).format("D");
        const filterResponse = array.filter(
          (x) =>
            moment(x.eventDate).format("YYYY-MM-DD") ==
            moment(day).format("YYYY-MM-DD")
        );

        let renderTime = "";
        switch (true) {
          case hours == 0:
            renderTime = "12am";
            break;
          case hours > 0 && hours < 12:
            renderTime = `${hours} am`;
            break;
          case hours == 12:
            renderTime = `Noon`;
            break;
          case hours > 12 && hours < 24:
            renderTime = `${hours - 12} pm`;
            break;
          default:
            renderTime = `${hours} am`;
            break;
        }
        days.push(
          <div
            className={`${i > 0 && "col"} ${[
              i == 0 ? classes.dayTime : classes.weeklyCell,
            ].join(" ")}`}
            key={day}
          >
            {i == 0 && (
              <span
                className={`${[classes.hours].join(" ")}`}
                style={{
                  color: Colors.neutralShadesOfDimGray,
                  ...Fonts.otherMedium,
                }}
              >
                {renderTime}
              </span>
            )}
            {i > 0 && filterResponse.length > 0 && (
              <>
                {filterResponse.map((item, i) => {
                  return moment(item.endTime).format("H") -
                    moment(item.startTime).format("H") ==
                    1 && moment(item.startTime).format("H") == hours ? (
                    <div
                      key={i}
                      className={`${[
                        classes.weeklyEventContainer,
                        classes.SingleBox,
                        (item?.status).toLocaleLowerCase() == "upcoming"
                          ? classes.upcoming
                          : (item?.status).toLocaleLowerCase() == "pending"
                          ? classes?.pending
                          : classes.past,
                        this.state.selectedItem?.id == item?.id &&
                          classes?.clickedEvent,
                      ].join(" ")} `}
                      onClick={(event) => {
                        this.setState({
                          selectedItem: item,
                          show: true,
                          anchorE1: event.currentTarget,
                        });
                      }}
                    >
                      <span className={classes.time}>
                        <HiClock /> {moment(item?.startTime).format("hh A")}
                        {" - "}
                        {moment(item?.endTime).format("hh A")}
                      </span>

                      <div className={classes.eventDetailContainer}>
                        <span className={classes.title}>{item?.title}</span>
                        <br />
                        <span className={classes.address}>
                          {item?.location}
                        </span>
                      </div>
                    </div>
                  ) : moment(item.startTime).format("H") < hours &&
                    moment(item.endTime).add(-1, "hours").format("H") >
                      hours ? (
                    <div
                      key={i}
                      className={`${[
                        classes.weeklyEventContainer,
                        classes.MiddleBox,
                        (item?.status).toLocaleLowerCase() == "upcoming"
                          ? classes.upcoming
                          : (item?.status).toLocaleLowerCase() == "pending"
                          ? classes?.pending
                          : classes.past,
                        this.state.selectedItem?.id == item?.id &&
                          classes?.clickedEvent,
                      ].join(" ")}
                      `}
                      onClick={(event) => {
                        this.setState({
                          selectedItem: item,
                          show: true,
                          anchorE1: event.currentTarget,
                        });
                      }}
                    ></div>
                  ) : moment(item.startTime).format("H") == hours ? (
                    <div
                      key={i}
                      className={`${[
                        classes.weeklyEventContainer,
                        classes.StartBox,
                        (item?.status).toLocaleLowerCase() == "upcoming"
                          ? classes.upcoming
                          : (item?.status).toLocaleLowerCase() == "pending"
                          ? classes?.pending
                          : classes.past,
                        this.state.selectedItem?.id == item?.id &&
                          classes?.clickedEvent,
                      ].join(" ")}
                      `}
                      onClick={(event) => {
                        this.setState({
                          selectedItem: item,
                          show: true,
                          anchorE1: event.currentTarget,
                        });
                      }}
                    >
                      <span className={classes.time}>
                        <HiClock /> {moment(item?.startTime).format("hh A")}
                        {" - "}
                        {moment(item?.endTime).format("hh A")}
                      </span>
                    </div>
                  ) : moment(item.endTime).add(-1, "hours").format("H") ==
                    hours ? (
                    <div
                      key={i}
                      className={`${[
                        classes.weeklyEventContainer,
                        classes.EndBox,
                        (item?.status).toLocaleLowerCase() == "upcoming"
                          ? classes.upcoming
                          : (item?.status).toLocaleLowerCase() == "pending"
                          ? classes?.pending
                          : classes.past,
                        this.state.selectedItem?.id == item?.id &&
                          classes?.clickedEvent,
                      ].join(" ")} 
                      `}
                      onClick={(event) => {
                        this.setState({
                          selectedItem: item,
                          show: true,
                          anchorE1: event.currentTarget,
                        });
                      }}
                    >
                      <div
                        className={`${[classes.eventDetailContainer].join(
                          " "
                        )}`}
                      >
                        <span className={classes.title}>{item?.title}</span>
                        <br />
                        <span className={classes.address}>
                          {item?.location}
                        </span>
                      </div>
                    </div>
                  ) : null;
                })}
              </>
            )}
          </div>
        );
        day = new Date(moment(day).add(1, "day").format());
      }
      rows.push(
        <div className={classes.cellRow} key={day}>
          {days}
        </div>
      );
      ++hours;
      day = new Date(moment(startDate).add(-1, "day").format());
      days = [];
    }
    return <div className={classes.dateCellContainer}>{rows}</div>;
  }

  renderMonthlyCells() {
    const { currentMonth, array } = this.state;
    const monthStart = new Date(moment(currentMonth).startOf("month").format());
    const monthEnd = new Date(moment(monthStart).endOf("month").format());
    const startDate = new Date(moment(monthStart).startOf("week").format());
    const endDate = new Date(moment(monthEnd).endOf("month").format());
    const rows = [];
    let days = [];
    let day = startDate;
    let formattedDate = "";
    let DayinChar = "";
    let isNextMonthFirstDate = false;
    let currentDay = 1;
    const onItemPress = (status) => {
      this.setState({
        show: true,
      });
      console.log(status);
    };
    const weekArray = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = moment(day).format("D");
        isNextMonthFirstDate =
          moment(monthEnd).add(1, "days").format("DD-MM-YYYY") ==
          moment(day).format("DD-MM-YYYY");
        DayinChar = moment(day).format("ddd");
        const filterResponse = array.filter(
          (x) =>
            moment(x.eventDate).format("YYYY-MM-DD") ==
            moment(day).format("YYYY-MM-DD")
        );
        days.push(
          <div
            className={`col  ${[
              classes.cell,
              moment(day).format("MMM") !== moment(monthStart).format("MMM")
                ? classes.disabled
                : "",
            ].join(" ")}`}
            key={day}
          >
            {currentDay < 8 && (
              <span
                className={`${[
                  classes.number,
                  classes.day,
                  classes.dayCharHideOnMobile,
                ].join(" ")}`}
              >
                {DayinChar}
              </span>
            )}
            <span
              className={`${[
                classes.number,
                currentDay < 8 && classes.firstRow,
              ].join(" ")} `}
            >
              {isNextMonthFirstDate && moment(day).format("MMM")}{" "}
              {formattedDate}
            </span>
            {filterResponse.length > 0 && (
              <>
                {filterResponse.map((item, i) => {
                  return filterResponse.length > 3 && i > 2 ? null : (
                    <div
                      key={i}
                      onClick={(event) => {
                        if (filterResponse.length > 3 && i == 2) {
                          return null;
                        }
                        this.setState({
                          selectedItem: item,
                          show: true,
                          anchorE1: event.currentTarget,
                        });
                      }}
                      className={`${[
                        classes.eventContainer,
                        filterResponse.length > 3 && i == 2
                          ? classes.moreContainer
                          : (item?.status).toLocaleLowerCase() == "upcoming"
                          ? classes.upcoming
                          : (item?.status).toLocaleLowerCase() == "pending"
                          ? classes?.pending
                          : classes.past,
                        this.state.selectedItem?.id == item?.id &&
                          classes?.clickedEvent,
                      ].join(" ")}`}
                    >
                      <span className={classes.eventText}>
                        {filterResponse.length > 3 && i == 2
                          ? `+ ${filterResponse.length - 2} more`
                          : `${moment(item?.startTime).format("hh:mm A")} ${
                              item?.title
                            }`}
                      </span>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        );
        day = new Date(moment(day).add(1, "day").format());
        currentDay = ++currentDay;
      }
      rows.push(
        <div className={classes.cellRow} key={day}>
          {days}
        </div>
      );
      days = [];
    }
    return (
      <div className={classes.dateCellContainer}>
        <div className={classes.cellRow}>
          {weekArray.map((item, index) => (
            <div
              className={`col ${[classes.cell, classes.dayStringHeader].join(
                " "
              )}`}
              key={index}
            >
              <span className={`${[classes.number, classes.day].join(" ")}`}>
                {item}
              </span>
            </div>
          ))}
        </div>
        {rows}
      </div>
    );
  }
  renderWeeklyForMobile() {
    const { currentMonth, selectedDate, array } = this.state;
    const startDate = new Date(moment(currentMonth).startOf("week").format());
    const monthStart = new Date(moment(currentMonth).startOf("month").format());
    const endDate = new Date(moment(currentMonth).endOf("week").format());
    const monthEndDate = new Date(moment(currentMonth).endOf("month").format());

    const rows = [];
    let days = [];
    let headerDays = [];
    let day = new Date(moment(selectedDate).format());
    let hours = 0;
    let formattedDate = "";
    let dayCount = 0;

    for (let i = 0; i <= 6; i++) {
      let weekStartDate = moment(monthStart)
        .add(dayCount, "days")
        .startOf("week")
        .format();
      let weekEndDate = moment(monthStart)
        .add(dayCount, "days")
        .endOf("week")
        .format();
      dayCount = dayCount + 7;
      if (
        moment(weekStartDate).format("DDD") < moment(monthEndDate).format("DDD")
      ) {
        headerDays.push(
          <div
            className={[
              classes.mobileWeekDateContainer,
              moment(this.state.selectedDate).format("DDD") ==
                moment(weekStartDate).format("DDD") &&
                classes.mobileWeekDateContainerActive,
            ].join(" ")}
            onClick={() => {
              this.setState({
                selectedDate: weekStartDate,
              });
            }}
          >
            <span className={classes.monthNameForWeekCalander}>
              {moment(currentMonth).format("MMM")}
            </span>
            <span className={classes.datesForWeekCalander}>
              {moment(weekStartDate).format("DD")} -{" "}
              {moment(weekEndDate).format("DD")}
            </span>
          </div>
        );
      }
    }
    rows.push(
      <div className={classes.weekDateWithMonthContainer}>{headerDays}</div>
    );
    headerDays = [];

    for (let i = 0; i < 7; i++) {
      formattedDate = moment(day).format("D");
      const filterResponse = array.filter(
        (x) =>
          moment(x.eventDate).format("YYYY-MM-DD") ==
          moment(day).format("YYYY-MM-DD")
      );

      days.push(
        <div className={`${[classes.monthlyWeeklyCell].join(" ")}`} key={day}>
          <div
            className={[
              classes.mobileWeekDateContainer,
              classes.mobileLeftWeekDateContainer,
            ].join(" ")}
          >
            <span className={classes.monthNameForWeekCalander}>
              {moment(day).format("MMM")}
            </span>
            <span className={classes.datesForWeekCalander}>
              {moment(day).format("DD")}
            </span>
          </div>

          <div className={classes.WeeklyEventContainer}>
            {filterResponse.length > 0 &&
              filterResponse.map((item, i) => {
                return (
                  <div
                    key={i}
                    className={`${[
                      classes.weeklyEventContainer,
                      (item?.status).toLocaleLowerCase() == "upcoming"
                        ? classes.upcoming
                        : (item?.status).toLocaleLowerCase() == "pending"
                        ? classes?.pending
                        : classes.past,
                      this.state.selectedItem?.id == item?.id &&
                        classes?.clickedEvent,
                    ].join(" ")} `}
                    onClick={(event) => {
                      this.setState({
                        selectedItem: item,
                        show: true,
                        anchorE1: event.currentTarget,
                      });
                    }}
                  >
                    <span className={classes.time}>
                      <HiClock /> {moment(item?.startTime).format("hh A")}
                      {" - "}
                      {moment(item?.endTime).format("hh A")}
                    </span>

                    <div className={classes.eventDetailContainer}>
                      <span className={classes.title}>{item?.title}</span>
                      <br />
                      <span className={classes.address}>{item?.location}</span>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      );
      day = new Date(moment(day).add(1, "day").format());

      rows.push(
        <div className={classes.cellRow} key={day}>
          {days}
        </div>
      );
      days = [];
    }

    return <div className={classes.dateCellContainer}>{rows}</div>;
  }

  resize = () =>
    this.setState({
      screenWidth: window.innerWidth,
    });

  handleClose = () => {
    this.setState({ show: false, anchorE1: null, selectedItem: null });
  };

  render() {
    return (
      <>
        <style>
          {`
      .MuiPopover-paper{
  box-shadow: unset !important;
  border-radius: 20px !important;
  overflow: visible !important;
      }
      `}
        </style>
        <div className={classes.calendar}>
          {this.state.screenWidth > 991
            ? this.renderHeader()
            : this.renderMobileHeader()}
          {this.state.screenWidth <= 991 &&
            this.state.calendarType == "month" &&
            this.renderMonthNameMobileHeader()}
          {this.state.calendarType == "week" &&
            this.state.screenWidth > 991 &&
            this.renderDays()}
          {this.state.calendarType == "day" &&
            this.state.screenWidth <= 991 &&
            this.renderDayMobileHeader()}
          {this.state.calendarType == "day" && this.renderDailyCells()}
          {this.state.calendarType == "week" &&
            (this.state.screenWidth > 991
              ? this.renderWeeklyCells()
              : this.renderWeeklyForMobile())}
          {this.state.calendarType == "month" && this.renderMonthlyCells()}

          <Popover
            id={this.state?.selectedItem?.id}
            open={this.state?.show}
            anchorEl={this?.state?.anchorE1}
            onClose={this.handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <div className={classes?.popoverContainer}>
              <LessonCard data={this.state.selectedItem} />
            </div>
          </Popover>
        </div>
      </>
    );
  }
}

export default CustomFullCalendar;
